<template>
  <BaseBottomSheet ref="dialog" @close="$emit('close')">
    <div class="w-full p-8 gap-8 flex flex-col bg-white rounded-t-xl shadow-xl">
      <!-- Header Section -->
      <div
        ref="header"
        class="w-full gap-2 flex flex-col items-center justify-center text-center"
      >
        <BaseIcon icon="undo" class="text-4xl text-primary" />
        <span class="text-3xl font-semibold text-gray-900">
          {{ $t('hub.paymentHistory.refundModal.title') }}
        </span>
      </div>

      <!-- Body Section -->
      <div class="gap-6 flex flex-col text-center text-gray-700">
        <p class="text-lg">
          {{ $t('hub.paymentHistory.refundModal.description') }}
        </p>

        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-sm text-gray-600 mb-2">
            {{ $t('hub.paymentHistory.refundModal.contactInfo') }}
          </p>
          <a
            href="mailto:capino.app@gmail.com"
            class="text-primary font-medium hover:underline"
          >
            capino.app@gmail.com
          </a>
        </div>

        <p class="text-sm text-gray-500">
          {{ $t('hub.paymentHistory.refundModal.note') }}
        </p>

        <!-- Action Button -->
        <div class="mt-6 flex justify-center">
          <BaseButton @click="handleClose">
            {{ $t('hub.paymentHistory.refundModal.understood') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </BaseBottomSheet>
</template>

<script>
import BaseBottomSheet from '@/components/Base/BaseBottomSheet.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'HubPaymentHistoryRefundModal',

  components: { BaseButton, BaseBottomSheet, BaseIcon },

  props: {
    payment: { type: Object, required: true }
  },

  methods: {
    handleClose() {
      this.$refs.dialog.handleClose()
    }
  }
}
</script>
